import React from 'react';
import { useNavigate } from 'react-router-dom';

// Navigation row shown at the top of the pull pages. `disabled` is set while
// a plan or apply is running so users can't wander off mid-operation.
function PullNav({ items, disabled }) {
    const navigate = useNavigate();
    return (
        <nav className="WriterPull__nav" aria-label="Page navigation">
            {items.map((item) => (
                <button
                    key={item.to}
                    className="WriterPull__nav-button"
                    disabled={disabled}
                    title={item.label}
                    onClick={() => navigate(item.to)}
                >
                    <i className={item.icon} aria-hidden="true"></i> {item.label}
                </button>
            ))}
        </nav>
    );
}

export default PullNav;
